import axios from 'axios';

export interface AxiosHandledError<T = unknown> {
   isAxiosError: true;
   status?: number;
   data?: T;
   message: string;
}

export function handleAxiosError<T = { err?: string; msg?: string }>(
   err: unknown
): AxiosHandledError<T> | null {
   if (axios.isAxiosError(err)) {
      const message =
         err.response?.data?.err ||
         err.response?.data?.msg ||
         err.message ||
         'Request failed';
      return {
         isAxiosError: true,
         status: err.response?.status,
         data: err.response?.data,
         message,
      };
   }
   return null;
}
